import {MEETING_STATUS_CANCELLED, MEETING_STATUS_CONFIRMED, MEETING_STATUS_PENDING} from 'common-data-handling';

export {
    MEETING_STATUS_PENDING as MEETING_PENDING,
    MEETING_STATUS_CONFIRMED as MEETING_CONFIRMED,
    MEETING_STATUS_CANCELLED as MEETING_CANCELLED,
} from 'common-data-handling';

export default {
    PENDING: MEETING_STATUS_PENDING,
    CONFIRMED: MEETING_STATUS_CONFIRMED,
    CANCELLED: MEETING_STATUS_CANCELLED,
};
